// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DeploymentUnitOutlinedSvg from "@fishx/icons-svg/es/asn/DeploymentUnitOutlined";
import FishxIcon from '../components/FishxIcon';

var DeploymentUnitOutlined = function DeploymentUnitOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DeploymentUnitOutlinedSvg
  }));
};

DeploymentUnitOutlined.displayName = 'DeploymentUnitOutlined';
export default React.forwardRef(DeploymentUnitOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DeploymentUnitOutlined.js
// module id = 2406
// module chunks = 0